var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeData.prepend !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "前缀" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入前缀" },
                model: {
                  value: _vm.activeData.prepend,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "prepend", $$v)
                  },
                  expression: "activeData.prepend",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.append !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "后缀" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入后缀" },
                model: {
                  value: _vm.activeData.append,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "append", $$v)
                  },
                  expression: "activeData.append",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["prefix-icon"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "前图标" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入前图标名称" },
                  model: {
                    value: _vm.activeData["prefix-icon"],
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "prefix-icon", $$v)
                    },
                    expression: "activeData['prefix-icon']",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "append", icon: "el-icon-thumb" },
                      on: {
                        click: function ($event) {
                          return _vm.openIconsDialog("prefix-icon")
                        },
                      },
                      slot: "append",
                    },
                    [_vm._v(" 选择 ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["suffix-icon"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "后图标" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入后图标名称" },
                  model: {
                    value: _vm.activeData["suffix-icon"],
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "suffix-icon", $$v)
                    },
                    expression: "activeData['suffix-icon']",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "append", icon: "el-icon-thumb" },
                      on: {
                        click: function ($event) {
                          return _vm.openIconsDialog("suffix-icon")
                        },
                      },
                      slot: "append",
                    },
                    [_vm._v(" 选择 ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.autosize !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "最小行数" } },
            [
              _c("el-input-number", {
                attrs: { min: 1, placeholder: "最小行数" },
                model: {
                  value: _vm.activeData.autosize.minRows,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.autosize, "minRows", $$v)
                  },
                  expression: "activeData.autosize.minRows",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.autosize !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "最大行数" } },
            [
              _c("el-input-number", {
                attrs: { min: 1, placeholder: "最大行数" },
                model: {
                  value: _vm.activeData.autosize.maxRows,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.autosize, "maxRows", $$v)
                  },
                  expression: "activeData.autosize.maxRows",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.minlength !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "最少输入" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入字符长度" },
                  model: {
                    value: _vm.activeData.minlength,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "minlength", $$v)
                    },
                    expression: "activeData.minlength",
                  },
                },
                [_c("template", { slot: "append" }, [_vm._v(" 个字符 ")])],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.minlength !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "最多输入" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入字符长度" },
                  model: {
                    value: _vm.activeData.maxlength,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "maxlength", $$v)
                    },
                    expression: "activeData.maxlength",
                  },
                },
                [_c("template", { slot: "append" }, [_vm._v(" 个字符 ")])],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["show-word-limit"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "输入统计" } },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v(" 输入统计 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        content: "在设置最少、最多输入属性之后显示当前组件字数",
                        effect: "dark",
                        placement: "top-start",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.activeData["show-word-limit"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "show-word-limit", $$v)
                  },
                  expression: "activeData['show-word-limit']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.config.dataType
        ? _c(
            "div",
            { staticClass: "reg-item" },
            [
              _vm.activeData.config.dataType
                ? _c(
                    "el-form-item",
                    { attrs: { label: "反馈类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.dataTypeChange },
                          model: {
                            value: _vm.activeData.config.dataType.type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.activeData.config.dataType,
                                "type",
                                $$v
                              )
                            },
                            expression: "activeData.config.dataType.type",
                          },
                        },
                        _vm._l(_vm.dataTypeList, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { value: option.value, label: option.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeData.config.dataType.type
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { label: "错误提示" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入错误提示" },
                        model: {
                          value: _vm.activeData.config.dataType.message,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.activeData.config.dataType,
                              "message",
                              $$v
                            )
                          },
                          expression: "activeData.config.dataType.message",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("icons-dialog", {
        attrs: {
          current: _vm.activeData[_vm.currentIconModel],
          visible: _vm.iconsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.iconsVisible = $event
          },
          select: _vm.setIcon,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }